export default {
  userPosts: "{name}'s posts",
  title: 'Scoreboard',
  widgetLoading: 'Loading standings…',
  widgetError: 'Standings are unavailable right now.',
  widgetEmptyTitle: 'Make the first move',
  widgetEmpty: 'Great posts start with your perspective. Share to LinkedIn or X and get your team on the board.',
  widgetEmptyHint: 'Scores appear once a post\'s engagement settles.',
  widgetOpen: 'Open Scoreboard',
  widgetPoints: 'pts',
  demo: 'Mock data · UI preview',
  mockData: 'Mock data',
  widgetRetry: 'Try again',
  subtitle: 'Good content. Real conversations. See who is making an impact.',
  monthly: 'Monthly standings',
  month: 'Publication month',
  channel: '{channel} · LinkedIn + X',
  rank: 'Rank',
  person: 'Team member',
  points: 'User score',
  posts: 'Scored posts',
  average: 'Average post',
  you: 'You',
  participants: 'Contributors',
  publishedPosts: 'Published posts',
  pendingTitle: 'Posts are in progress',
  pendingBody: "Your team has shared {count} posts. Scores will appear here when they’re ready.",
  collecting: 'Collecting results',
  countsUnavailable: 'Counts unavailable',
  eligible: 'Completed posts',
  yourScore: 'Your score',
  unranked: 'Not ranked yet',
  ownRank: 'Your place',
  emptyTitle: 'The first spot is waiting',
  emptyBody: 'Share to LinkedIn or X from Studio. Posts join the standings once their engagement settles.',
  browse: 'Find something to share',
  how: 'How scoring works',
  howBody: 'Your monthly total is the sum of final post scores for posts published that month. Available engagement counts are checked four times a day. A successful reading becomes final after seven days without a change in measured engagement, or 30 days after posting. Missing measurements remain pending.',
  engagement: 'Engagement',
  audience: 'Audience response',
  conversation: 'Conversation quality',
  content: 'Content quality',
  bonus: 'Outcome bonuses stay separate and do not affect these standings.',
  methodology: 'Post scores combine reactions and comments with response relative to audience size. The formula has diminishing returns; connecting an account alone earns no points.',
  updated: 'Last updated {date}',
  noUpdates: 'Waiting for the first measurement',
  source: 'Post score v2.1 · Measured until engagement settles · Personal profiles',
  connectionTitle: 'Bring your impact into focus',
  connectionBody: 'Public posts shared from Studio are measured automatically when their counts are visible. Connect LinkedIn analytics for additional measurements. Your publishing connection stays separate.',
  connect: 'Connect LinkedIn analytics',
  reconnect: 'Reconnect LinkedIn analytics',
  connected: 'LinkedIn analytics connected',
  connectedBody: 'Measurements sync four times a day. New posts need a follower count within 24 hours.',
  notConfigured: 'Public LinkedIn posts shared from Studio are measured automatically when their counts are visible.',
  disconnect: 'Disconnect analytics',
  disconnectConfirm: 'Disconnect LinkedIn analytics? Connected analytics will pause. Public post measurements can continue.',
  published: 'Published {date}',
  outcomeUnavailable: 'Outcome bonus unavailable',
  outcomeValue: 'Outcome bonus +{points} · excluded from standings',
  yourPosts: 'Your posts in progress',
  recentBody: 'Published posts appear here immediately. Final scores join the standings once engagement settles.',
  noPosts: 'No measured posts for this month yet.',
  partial: 'Measured points · partial',
  complete: 'Post score',
  pending: 'Measurement pending',
  statusPending: 'Pending',
  statusPartial: 'Partial',
  scoresOn: 'Scores {date}',
  review: 'Review post',
  openPost: 'View post',
  reviewTitle: 'Review the complete post',
  reviewIntro: 'Inspect the full post and its material media. Record every comment from its measured period, including replies, author comments, generic responses and criticism. Studio selects the earliest in-window comment per external commenter.',
  inspected: 'I inspected the post and all material media.',
  commentsComplete: 'I inspected the complete comment set for the measured period.',
  contentRatings: 'Content review · each criterion is 0–4',
  clarity: 'Clarity and focus',
  specificity: 'Specificity and support',
  usefulness: 'Usefulness and insight',
  structure: 'Structure and readability',
  presentation: 'Presentation and format fit',
  rationale: 'Review evidence and rationale',
  commentsReview: 'External commenters',
  commentsHelp: 'Use stable platform user IDs or profile URLs, not display names. Mark author comments so they are excluded from quality scoring. Leave the list empty only when the complete set has no comments. Include the complete set; Studio selects a fixed sample when there are more than 100 distinct commenters.',
  addComment: 'Add commenter',
  remove: 'Remove',
  authorComment: 'This comment is by the post author',
  commentId: 'Comment ID',
  commenterId: 'Commenter ID or profile URL',
  commentTime: 'Comment time (UTC)',
  specificityRating: 'Specificity / context (0–2)',
  contributionRating: 'Contribution (0–3)',
  commentEvidence: 'Comment evidence and rationale',
  specificityHelp: '0 generic; 1 identifiable connection; 2 concrete firsthand or developed context.',
  contributionHelp: '0 praise/reaction; 1 relevant observation; 2 supporting detail or specific question; 3 substantive insight or counterpoint.',
  verificationSource: 'Verification source URL',
  verificationEvidence: 'Supporting evidence',
  classification: 'Distribution classification',
  organic: 'Organic',
  paid: 'Paid / promoted',
  unchanged: 'Keep current verification',
  countDefinition: 'Verified source comment definition',
  includesReplies: 'Comments include replies',
  excludesReplies: 'Comments exclude replies',
  definitionHelp: 'Only change these after verifying the source definition and distribution. Record the supporting evidence below. Paid posts belong to a separate comparison cohort.',
  correction: 'Reason for this review or correction',
  saveReview: 'Save review',
  saving: 'Saving…',
  cancel: 'Cancel',
  reviewError: 'The review could not be saved. Check the evidence and try again.',
  reviewSaved: 'Review saved.',
  close: 'Close',
  coverage: 'What is still needed',
  reasons: {
    incomparable_comment_count_definition: 'This board requires a verified comment count including replies; other definitions cannot be compared here.',
    incomplete_core_score: 'Complete measurements and both reviews are needed.',
    comment_count_definition_unknown: 'Verify whether the source comment count includes replies.',
    organic_classification_unverified: 'Verify that this post had organic distribution.',
    no_frozen_follower_baseline: 'A publication-time follower baseline is unavailable.',
    follower_baseline_outside_24h: 'The follower baseline was not captured within 24 hours.',
    invalid_seven_day_window: 'A complete measurement is needed.',
    capture_outside_day_seven_hour: 'The day-seven capture missed the allowed one-hour window.',
    no_valid_seven_day_window: 'The final measurement has not been captured.',
    public_counts_unavailable: 'LinkedIn is not exposing usable public counts for this post. Its score remains pending.',
    provider_unconfirmed: 'The provider has not returned confirmed measurements. Its score remains pending.',
    measurement_pending: 'Waiting for the first reading.',
    measurement_window_incomplete: 'Still collecting engagement. Final after seven days with no new activity.',
    invalid_measurement_window: 'A complete measurement is needed.',
    missing_follower_baseline: 'A follower baseline from publication is needed.',
    incomplete_score: 'Complete measurements and reviews are needed.',
    incomplete_comment_review: 'A complete comment review is needed.',
    incomplete_content_review: 'A complete content review is needed.',
    missing_comments: 'Comment counts are unavailable.',
    missing_reactions: 'Reaction counts are unavailable.',
    missing_follower_count: 'Follower count is unavailable.',
    unsupported_post_id: 'The post needs a supported platform post identifier.',
    author_mismatch: 'Connect the account that published this post.',
    capture_outside_window: 'The day-seven capture missed its measurement window.',
    unsupported_account_type: 'This ranking is for personal profiles.',
    version_mismatch: 'This post uses a different scoring version.',
    unknown: 'This post needs more measurement or review coverage before it can be ranked.',
  },
}
